// extracted by mini-css-extract-plugin
export default {"modal":"PostLogModal_modal__hYzRO","modalContent":"PostLogModal_modalContent__OInDV","logBox":"PostLogModal_logBox__Vhdto","topRow":"PostLogModal_topRow__3v-ux"};